import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Text } from "@fluentui/react-northstar";

// Reusable Bar Chart component using ApexCharts
const BarChart = ({
  title,
  categories,
  data,
  colors = "#3B82F6",
  xaxisTitle = "",
  yaxisTitle = "",
  height = 350,
}) => {
  // Configure ApexChart options
  const options = {
    chart: {
      type: "bar",
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        borderRadius: 3,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: Array.isArray(colors) ? colors : [colors],
    xaxis: {
      categories: categories,
      title: {
        text: xaxisTitle,
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      title: {
        text: yaxisTitle,
        style: {
          fontSize: "12px",
          fontWeight: 500,
        },
      },
    },
    title: {
      text: title,
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: 600,
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return value.toLocaleString() + " credits";
        },
      },
    },
  };

  // Data series for the chart
  const series = [
    {
      name: "Credits Used",
      data: data,
    },
  ];

  return (
    <Box style={{ marginBottom: "2rem" }}>
      <div className="chart-container">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={height}
        />
      </div>
    </Box>
  );
};

export default BarChart;
